module.exports = __webpack_public_path__ + "img/emet.a3562d52.png";